import createPortalProvider from './createPortalProvider'
import PopoversLayer from './PopoversLayer'

const {
  Portal: PopoversPortal,
  PortalProvider: PopoversLayerProvider,
  usePortal: usePopoversContainer,
} = createPortalProvider({
  displayName: 'Popovers',
  // defaultContainer: document.body,
  Layer: PopoversLayer,
})

export {PopoversLayerProvider, usePopoversContainer}
export default PopoversPortal
